// ************************************************************************************************
// pathname: /v1/resume/interview-video/delete-all
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';

interface UseSwrResumeInterviewVideoDeleteAllProps {
  locale: string;
  successCallback?: () => void;
  errorCallback?: () => void;
}

/**
 * @description SWR mutation: Delete All AI Interview Videos
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. The callback to call on success.
 * @param errorCallback - function. The callback to call on error.
 */
export const useSwrResumeInterviewVideoDeleteAll = (
  props: UseSwrResumeInterviewVideoDeleteAllProps,
) => {
  const { locale = 'ro', successCallback, errorCallback } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, never>({
    url: '/v1/resume/interview-video/delete-all',
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => successCallback?.(),
      onError: () => errorCallback?.(),
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
